<div class="systems-container">

  <div class="system-card LUK" (click)="routeToNewOrder('LUK')">
    <div class="system">
      <img src="../../assets/images/luki.svg">

      <p id="luki" [translation]="TranslationEnum.Translation">
        {{'luki' | translate}}
      </p>
    </div>
  </div>

  <div class="system-card PAN" (click)="routeToNewOrder('PAN')">
    <div class="system">
      <img src="../../assets/images/panele.svg">

      <p id="panele" [translation]="TranslationEnum.Translation">
        {{'panele' | translate}}
      </p>
    </div>
  </div>

  <div class="system-card SZK" (click)="routeToNewOrder('SZK')">
    <div class="system">
      <img src="../../assets/images/szklo.svg">

      <p id="szklo" [translation]="TranslationEnum.Translation">
        {{'szklo' | translate}}
      </p>
    </div>
  </div>

</div>